<template>
  <!-- Header -->
  <header class="z-9999 position-relative">
    <div class="banner-header hiw">
      <div class="header-area home-5">
        <Topbar />
      </div>
      <div class="row">
        <div class="col-12 col-md-5 md:col-span-7"></div>
        <div class="banner-text-main animate__animated animate__fadeInUp">
          <div class="container-xl">
            <div class="row justify-start">
              <div class="col-12 col-lg-7">
                <h1
                  class="mb-2 lg:ml-4/6 text-white text-left"
                >Médicos 24h a tu disposición, cualquier día de la semana.</h1>
                <h2 class="mb-10 text-white text-left">Datos del afiliado</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import Topbar from '@/components/home/Topbar';
export default {
  components: {
    Topbar,
  },
};
</script>

<style scoped>
.hiw {
  background: url('~@/assets/img/newletter.jpg') no-repeat fixed top !important;
  position: relative;
  height: 400px;
  clip-path: polygon(0 0, 100% 0, 100% 90%, 0 100%);
  -webkit-clip-path: polygon(0 0, 100% 0, 100% 90%, 0 100%);
}
.hiw::before {
  position: absolute;
  content: '';
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.25);
}
</style>
